import { later, next } from '@ember/runloop';
import { service } from '@ember/service';

import $ from 'jquery';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class QbSheetsTour extends TourBase {
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;

	static keyForPersistantDone = UserSettingsKey.QB_SHEETS;

	get id(): string {
		return TourId.QB_SHEETS;
	}

	override get keyForPersistantDone(): string {
		return QbSheetsTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				step: 1,
				direction: Direction.RIGHT,
				attachTo: function () {
					return $('.form--custom-query input[name="metric"]').eq(0);
				},
				doAction: () => {
					next(() => {
						later(() => {
							$('.form--custom-query input[name="date"]').trigger('focus');
						}, 400); // this is an ugly hack bcos of popup unload animation time
					});
				},
			},
			{
				step: 2,
				direction: Direction.RIGHT,
				attachTo: function () {
					return $('.form--custom-query input[name="date"]').eq(0);
				},
				doAction: () => {
					next(() => {
						later(() => {
							$('.form--custom-query input[name="dimension"]').trigger('focus');
							this.hideBubble();
						}, 400); // this is an ugly hack bcos of popup unload animation time
					});
				},
			},
		];
	}

	override start(): void {
		if (
			this.mmCustomQueriesService.customQueryModels.filter((item) => item.isSheets).length ===
			2
		) {
			this.markDone();
			return;
		}

		super.start();
	}

	override onExplicitClose(): void {
		this.hideBubble(); // prevent calling end method and marking tour down, since we have condition in start method
	}
}
